// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"cd2d2bc8","596":"8a8bff20"}[chunkId] + ".chunk.css";
};